import { Box, Modal, keyframes } from "@mui/material";
import { styled } from "@mui/material/styles";
import ClaimPrize from "./ClaimPrize";

interface BigWinModalProps {
  open: boolean;
  onClose: () => void;
}

/* === ANIMACIJE === */
const raysSpinCCW = keyframes`
   0% { transform: rotate(-25deg) scale(1.8); }
  50% { transform: rotate(25deg) scale(1.8); }
  100% { transform: rotate(-25deg) scale(1.8); }
`;

const raysSpinCW = keyframes`
  0% { transform: rotate(20deg) scale(1.8); }
  50% { transform: rotate(-20deg) scale(1.8); }
  100% { transform: rotate(20deg) scale(1.8); }
`;

const pulseRing = keyframes`
  0% { opacity: 0.3; transform: translateX(-50%) scale(1); }
  50% { opacity: 0.6; transform: translateX(-50%) scale(1.05); }
  100% { opacity: 0.3; transform: translateX(-50%) scale(1); }
`;

const StyledModal = styled(Modal)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

/* === POZADINA === */
const BackgroundOverlay = styled(Box)({
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundImage: `url("/pocetna-stranica.png")`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  filter: "blur(2px) brightness(0.7)",
  zIndex: -1,
});

const SunRayLayerCCW = styled(Box)({
  position: "fixed",
  inset: 0,
  zIndex: 0,
  backgroundImage: `url("/sun-rayBG.png")`,
  backgroundSize: "120% 120%",
  backgroundPosition: "center",
  mixBlendMode: "screen",
  backgroundColor: "#01253F",
  opacity: 0.2,
  animation: `${raysSpinCCW} 38s linear infinite`,
  pointerEvents: "none",
});

const SunRayLayerCW = styled(Box)({
  position: "fixed",
  inset: 0,
  zIndex: 0,
  backgroundImage: `linear-gradient(#01253F 0%, #00192B 100%), url("/sun-rayBG.png")`,
  backgroundSize: "120% 120%",
  backgroundPosition: "center",
  mixBlendMode: "screen",
  opacity: 0.22,
  animation: `${raysSpinCW} 34s linear infinite`,
  animationDelay: "3s",
  pointerEvents: "none",
});

const FrameImage = styled(Box)(({ theme }) => ({
  width: "90vw",
  maxWidth: "500px", // gornja granica za desktop
  aspectRatio: "1 / 1", // zadrži kvadratni oblik
  backgroundImage: `url("/frame.png")`,
  backgroundSize: "contain",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  position: "relative",
  zIndex: 2,
  filter: "drop-shadow(0 0 20px rgba(0, 0, 0, 0.5))",

  [theme.breakpoints.down("sm")]: {
    width: "80vw", // malo manja širina na mobitelima
  },
}));

const PulseRing = styled(Box)({
  position: "absolute",
  bottom: "55px",
  left: "50%",
  transform: "translateX(-50%)",
  width: "270px",
  height: "75px",
  borderRadius: "37px",
  border: "1.5px solid rgba(255, 255, 255, 0.2)",
  animation: `${pulseRing} 3s ease-in-out infinite`,
  zIndex: 1,
  pointerEvents: "none",
});

const ClaimPrizeHotspot = styled(Box)({
  position: "absolute",
  bottom: "55px",
  left: "50%",
  transform: "translateX(-50%)",
  width: "260px",
  height: "70px",
  cursor: "pointer",
  zIndex: 3,
  background: "transparent",
  borderRadius: "35px",
});

export const BigWinModal = ({ open, onClose }: BigWinModalProps) => {
  return (
    <StyledModal
      open={open}
      onClose={onClose}
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(0, 0, 0, 0.6)",
          backdropFilter: "blur(4px)",
        },
      }}
    >
      <Box
        position="relative"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        sx={{
          overflow: "hidden",
          width: "100%",
          height: "100%",
          gap: "20px", // razmak između framea i dugmeta
        }}
      >
        <BackgroundOverlay />
        <SunRayLayerCCW />
        <SunRayLayerCW />

        <FrameImage>
          <PulseRing />
          <ClaimPrizeHotspot onClick={onClose} />
        </FrameImage>

        {/* === ClaimPrize dugme ispod framea === */}
        <ClaimPrize onClick={onClose} />
      </Box>
    </StyledModal>
  );
};
